import a from "./index290.js";
import { resolveComponent as c, createElementBlock as n, openBlock as o, createElementVNode as t, normalizeClass as i, createBlock as d, resolveDynamicComponent as m, createCommentVNode as p, renderSlot as u, toDisplayString as f, createVNode as h } from "vue";
/* empty css         */
import _ from "./index231.js";
const b = ["data-component"], k = { class: "py-16" }, v = {
  key: 0,
  class: "mb-4 font-bold",
  "data-test-id": "title"
};
function C(e, s, y, $, w, B) {
  const l = c("ms-close");
  return o(), n("div", {
    "data-component": e.$options.name,
    class: "flex items-center bg-color-neutral-black rounded-10 text-color-neutral-white"
  }, [
    t("div", {
      class: i(["flex items-center justify-center w-40 h-40 m-16 rounded-full shrink-0", e.computedBgColor])
    }, [
      (o(), d(m(e.computedIcon), { class: "w-24 h-24" }))
    ], 2),
    t("div", k, [
      e.title ? (o(), n("div", v, f(e.title), 1)) : p("", !0),
      u(e.$slots, "default", {}, void 0, !0)
    ]),
    t("button", {
      type: "button",
      "aria-label": "close toast",
      class: "p-16 ml-auto shrink-0",
      onClick: s[0] || (s[0] = (...r) => e.close && e.close(...r))
    }, [
      h(l, { class: "w-24 h-24 text-color-neutral-white" })
    ])
  ], 8, b);
}
const E = /* @__PURE__ */ _(a, [["render", C], ["__scopeId", "data-v-7c1583b2"]]);
export {
  E as default
};
